/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useEffect, useMemo } from 'react';
import { getProjectKeyOrId } from '@jira/router-resources__utils/src/getProjectKeyOrId.tsx';
import type { DataState } from '@atlassian/jira-common-services/src/types.tsx';
import { createResource, useResource, type RouteResource } from '@atlassian/react-resource-router';
import type { ServiceDeskAnalyticAttributes } from './ServiceDeskAnalyticAttributes.types.tsx';

const RESOURCE_TYPE_SERVICEDESK_ANALYTICS_CONTEXT = 'SERVICEDESK_ANALYTICS_CONTEXT';

const ONE_DAY_IN_MILLIS = 60 * 60 * 1000 * 24;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const serviceDeskAnalyticsContextResource: RouteResource<any> = createResource<any>({
	type: RESOURCE_TYPE_SERVICEDESK_ANALYTICS_CONTEXT,
	getKey: ({ match }) => getProjectKeyOrId(match),
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-servicedesk-analytics-context", jiraSpaEntry: "async-resource-servicedesk-analytics-context" */ './getData.tsx'
		),
	maxAge: ONE_DAY_IN_MILLIS,
});
export const useServiceDeskAnalyticsContext: () => DataState<ServiceDeskAnalyticAttributes> =
	() => {
		const { data, loading, error, refresh } = useResource(serviceDeskAnalyticsContextResource);
		useEffect(() => {
			if (!data && !loading && !error) {
				refresh();
			}
		}, [data, loading, error, refresh]);
		return useMemo(
			() => ({
				data,
				loading,
				// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
				error: error as Error,
			}),
			[data, loading, error],
		);
	};
